import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyDelicateIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./DelicateIcon-7826088e.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyDelicateIcon as P };
